import { useMutation } from '@tanstack/react-query';
import { deleteProject } from "@/api/project"; 
import { GetDeleteProjectData, ReturnProjectData } from "@/types/project"; 
import { PostParam } from "@/types/index"; 

export function useDeleteProject(props?: PostParam) {
  const { onSuccess, onError } = props || {};

  return useMutation<ReturnProjectData, Error, GetDeleteProjectData>({
    mutationFn: deleteProject,
    onSuccess,
    onError 
  });
}